import { Typography } from 'antd';
import { StyledThemeCard } from './ThemeCard.styled';
import Image from 'next/legacy/image';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import CardSelector from '../CardSelector/CardSelector';
import ThemeActivityIcons from './ThemeActivityIcons/ThemeActivityIcons';
import Link from 'next/link';
import getMainActivity from '@/modules/activities/getMainActivity';

const { Paragraph, Title } = Typography;

export default function ThemeCard({
  theme,
  themeRefs,
  allowFavourite,
  markAsFavourite,
  unmarkAsFavourite,
  allowSelection,
  selectedThemes,
  addingThemes,
  addSelectedTheme,
  removeSelectedTheme,
  keepScroll,
  publicPage,
}) {
  const isSelected = selectedThemes?.some(
    (selectedTheme) => selectedTheme.id == theme.id
  );

  const mainActivity = getMainActivity(theme);

  const slug = publicPage
    ? mainActivity.slug
    : `library/activities/${mainActivity.slug}`;

  return (
    <StyledThemeCard className="theme-card">
      {allowSelection && addingThemes ? (
        <CardSelector
          isSelected={isSelected}
          onAdd={() => addSelectedTheme(theme)}
          onRemove={() => removeSelectedTheme(theme)}
        />
      ) : null}
      <div
        className="theme"
        ref={(ref) =>
          (themeRefs.current = {
            ...themeRefs.current,
            [theme.id]: ref,
          })
        }
      >
        <Link
          href={slug}
          className="theme-layout"
          onClick={addingThemes ? () => {} : () => keepScroll(theme.id)}
          passHref
        >
          <div className="theme-image">
            {theme.thumb ? (
              <Image
                src={theme.thumb}
                alt={theme.name}
                layout="fill"
                objectFit="cover"
              />
            ) : (
              <div className="placeholder"></div>
            )}
          </div>
          <div className="theme-content">
            <Title level={3} className="theme-name">
              {theme.name}
            </Title>
            <Title level={4} className="theme-subname">
              {theme.englishName}
            </Title>
            <Paragraph className="theme-description">
              {theme.shortDescription}
            </Paragraph>
            <ThemeActivityIcons theme={theme} />
          </div>
          <div className="theme-favourite">
            {allowFavourite && (
              <div
                className={`favourite-icon ${
                  theme.isFavourite ? 'active' : ''
                }`}
              >
                {theme.isFavourite ? (
                  <StarFilled
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      unmarkAsFavourite(theme.id);
                    }}
                  />
                ) : (
                  <StarOutlined
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      markAsFavourite(theme.id);
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </Link>
      </div>
    </StyledThemeCard>
  );
}
